///
/// EarthBrowser
///
/// Created by Matt Giger on 11/28/2025
/// Copyright (c) 2025 Geodata Labs
///

export interface LoggingInterface {
	log(message: string, ...params: unknown[]): void
	info(message: string, ...params: unknown[]): void
	warn(message: string, ...params: unknown[]): void
	error(error: unknown, ...params: unknown[]): void
	assert(condition: boolean, message: string, ...params: unknown[]): void
}

export class EmptyLogger implements LoggingInterface {
	log(_message: string, ..._params: unknown[]): void {}
	info(_message: string, ..._params: unknown[]): void {}
	warn(_message: string, ..._params: unknown[]): void {}
	error(_message: string, ..._params: unknown[]): void {}
	assert(_condition: boolean, _message: string, ..._params: unknown[]): void {}
}

export class ConsoleLogger extends EmptyLogger {
	override log(message: string, ...params: unknown[]): void {
		console.log(message, params)
	}
	override info(message: string, ...params: unknown[]): void {
		console.info(message, params)
	}
	override warn(message: string, ...params: unknown[]): void {
		console.warn(message, params)
	}
	override error(error: unknown, ...params: unknown[]): void {
		let description = "Unknown error"
		if (error instanceof Error) {
			description = error.message
		} else if (typeof error === "string") {
			description = error
		}

		console.error(description, params)
	}
	override assert(condition: boolean, message: string, ...params: unknown[]): void {
		console.assert(condition, message, params)
	}
}